import {BrowserRouter, Route, Routes, useMatches} from "react-router-dom";
import NavBar from "./components/navBarComponents/NavBar";
import Installations from "./components/Installations/Installations";
import Users from "./components/Users/Users";
import Devices from "./components/Devices/Devices";
import Triggers from "./components/Triggers/Triggers";
import 'mapbox-gl/dist/mapbox-gl.css';
import Page404 from "./components/ErrorPage/Page404";
import LoginComponent from "./components/LoginComponent";
import {useSelector} from "react-redux";
import {
    getAutoRedirect,
    getUserInfo,
    isAuthenticated,
    messageNotificationGlobal,
    showMessageNotificationGlobal,
    titleNotificationGlobal,
    typeNotificationGlobal
} from "./redux-store/selectors";
import MapLocationDevices from "./components/Home/Map/MapLocationDevices";
import Home from "./components/Home/Home";
import ProtectedRoute from "./components/ProtectedRoute";
import {useEffect} from "react";
import {openNotification} from "./components/NotificationBox";
import TableConfigListView from "./components/TableConfig/TableConfigListView";
import ChangePassword from "./components/ChangePassword";
import {checkSuperUser, checkUserPermissions} from "./components/authHelpers";
import TwoFALoginComponent from "./components/TwoFALoginComponent";
import MapLocation from "./components/Home/Map/MapLocation";
import TablesHomePage from "./components/Home/TablesHomePage/TablesHomePage";
import AlarmsTable from "./components/Home/Alarms/AlarmsTable";
import HomePageTabs from "./components/Home/HomePageTabs";
import Agreement from "./components/Agreement";

function App() {

    const authenticated = useSelector(isAuthenticated);
    const showNotification = useSelector(showMessageNotificationGlobal)
    const messageNotification = useSelector(messageNotificationGlobal)
    const typeNotification = useSelector(typeNotificationGlobal)
    const titleNotification = useSelector(titleNotificationGlobal)
    const autoRedirect = useSelector(getAutoRedirect);
    const userInfo = useSelector(getUserInfo);

    useEffect(() => {
        if (showNotification) {
            openNotification(typeNotification.notificationStatus, messageNotification.message, titleNotification.title);
        }
    }, [showNotification, messageNotification])

    return (
        <BrowserRouter>
            {authenticated && autoRedirect === null && <NavBar/>}
            <Routes>
                <Route element={<LoginComponent/>} path={"/login"}/>
                <Route element={<TwoFALoginComponent/>} path={"/two_fa"}/>
                <Route
                    path="/change_password"
                    element={
                        <ProtectedRoute>
                            <ChangePassword/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    element={
                        <ProtectedRoute>
                            <Home/>
                        </ProtectedRoute>
                    }
                >
                    <Route path={"/"} element={<MapLocation/>}/>
                    <Route path={"/map_tables"} element={<TablesHomePage/>}/>
                    <Route path={"/map_alarms"} element={<AlarmsTable/>}/>
                </Route>
                <Route
                    path="/installations"
                    element={
                        <ProtectedRoute isAllowed={(checkUserPermissions(userInfo) && !checkSuperUser(userInfo))} redirectPath={"/"}>
                            <Installations/>
                        </ProtectedRoute>
                    }
                />
                <Route exact  path={"/location-devices"} element={
                    <ProtectedRoute>
                        <MapLocationDevices/>
                    </ProtectedRoute>
                }/>
                <Route
                    path="/users"
                    element={
                        <ProtectedRoute>
                            <Users/>
                        </ProtectedRoute>
                    }
                />
                <Route path={"/devices"}
                       element={
                    <ProtectedRoute isAllowed={checkUserPermissions(userInfo)} redirectPath={"/"}>
                        <Devices/>
                    </ProtectedRoute>
                }
                />
                <Route
                    path="/tables"
                    element={
                        <ProtectedRoute isAllowed={checkUserPermissions(userInfo)} redirectPath={"/"}>
                            <TableConfigListView/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/triggers"
                    element={
                        <ProtectedRoute isAllowed={checkUserPermissions(userInfo)} redirectPath={"/"}>
                            <Triggers/>
                        </ProtectedRoute>
                    }
                />
                <Route
                    path="/agreement"
                    element={
                        <Agreement/>
                    }
                />
                <Route path={"*"} element={<Page404/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
